

const FAQ = () => {
    return (
        <div className="bg-[white] dark:bg-dark-content-bg dark:text-white px-10  transition-colors duration-300 ease-in-out">

            <div className="flex flex-col items-center pt-10">
                <h1 className="text-lg md:text-xl lg:text-3xl font-bold">Frequently Asked Questions</h1>
                <div className='mt-16'>
                    <ul>

                        <li className='flex max-w-[65ch] mb-12'>
                            <div className="w-[100px] rounded-[1000px] mr-5">
                                <img src = 'https://images.unsplash.com/photo-1618614944895-fc409a83ad80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80'
                                 alt = 'profilepicture' className='w-full h-[auto] rounded-[50%]'/>
                            </div>    
                            <div className='flex flex-col'>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl '>What is X-Market?</p>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-[#808080]'>
                                    X-Market is the revolutionary NFT marketplace currently allowing users to buy/sell Solana based NFTs without any listing fees.
                                </p>
                            </div>
                        </li>

                        <li className='flex max-w-[65ch] mb-12'>
                            <div className="w-[100px] rounded-[1000px] mr-5">
                                <img src = 'https://images.unsplash.com/photo-1618614944895-fc409a83ad80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80'
                                 alt = 'profilepicture' className='w-full h-[auto] rounded-[50%]'/>
                            </div>    
                            <div className='flex flex-col'>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl '>What is X-Market?</p>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-[#808080]'>
                                    X-Market is the revolutionary NFT marketplace currently allowing users to buy/sell Solana based NFTs without any listing fees.
                                </p>
                            </div>
                        </li>
                        
                        <li className='flex max-w-[65ch] mb-12'>
                            <div className="w-[100px] rounded-[1000px] mr-5">
                                <img src = 'https://images.unsplash.com/photo-1618614944895-fc409a83ad80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80'
                                 alt = 'profilepicture' className='w-full h-[auto] rounded-[50%]'/>
                            </div>    
                            <div className='flex flex-col'>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl '>What is X-Market?</p>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-[#808080]'>
                                    X-Market is the revolutionary NFT marketplace currently allowing users to buy/sell Solana based NFTs without any listing fees.
                                </p>
                            </div>
                        </li>

                        <li className='flex max-w-[65ch] mb-12'>
                            <div className="w-[100px] rounded-[1000px] mr-5">
                                <img src = 'https://images.unsplash.com/photo-1618614944895-fc409a83ad80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80'
                                 alt = 'profilepicture' className='w-full h-[auto] rounded-[50%]'/>
                            </div>    
                            <div className='flex flex-col'>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl '>What is X-Market?</p>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-[#808080]'>
                                    X-Market is the revolutionary NFT marketplace currently allowing users to buy/sell Solana based NFTs without any listing fees.
                                </p>
                            </div>
                        </li>

                        <li className='flex max-w-[65ch] mb-12'>
                            <div className="w-[100px] rounded-[1000px] mr-5">
                                <img src = 'https://images.unsplash.com/photo-1618614944895-fc409a83ad80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80'
                                 alt = 'profilepicture' className='w-full h-[auto] rounded-[50%]'/>
                            </div>    
                            <div className='flex flex-col'>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl '>What is X-Market?</p>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-[#808080]'>
                                    X-Market is the revolutionary NFT marketplace currently allowing users to buy/sell Solana based NFTs without any listing fees.
                                </p>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
            
        </div>
    )
}

export default FAQ;